import type {
  UkTaxSummary,
  UkSaEstimate,
  UkTaxBoxes,
  VatReturnDraft,
  MtdStatus,
  Ct600Summary,
  CisSubcontractor,
  Cis300Draft,
  UkTaxDeadline,
  TaxFilingDraftSummary,
} from '@eriko/shared-types';
import { apiClient } from '../lib/api';

export async function getUkTaxSummary(orgId: string, taxYear?: string): Promise<UkTaxSummary> {
  const { data } = await apiClient.get('/taxes/summary', { params: { orgId, ...(taxYear && { taxYear }) } });
  return data;
}

export async function getUkSaEstimate(orgId: string, taxYear?: string): Promise<UkSaEstimate> {
  const { data } = await apiClient.get('/taxes/sa-estimate', { params: { orgId, ...(taxYear && { taxYear }) } });
  return data;
}

export async function getUkTaxBoxes(orgId: string, taxYear?: string): Promise<UkTaxBoxes> {
  const { data } = await apiClient.get('/taxes/boxes', { params: { orgId, ...(taxYear && { taxYear }) } });
  return data;
}

export async function getVatReturn(orgId: string, periodStart: string, periodEnd: string): Promise<VatReturnDraft> {
  const { data } = await apiClient.get('/taxes/vat-return', { params: { orgId, periodStart, periodEnd } });
  return data;
}

export async function getMtdStatus(orgId: string): Promise<MtdStatus> {
  const { data } = await apiClient.get('/taxes/mtd-status', { params: { orgId } });
  return data;
}

export async function getCt600(orgId: string, taxYear?: string): Promise<Ct600Summary> {
  const { data } = await apiClient.get('/taxes/ct600', { params: { orgId, ...(taxYear && { taxYear }) } });
  return data;
}

export async function getCisSubcontractors(orgId: string): Promise<CisSubcontractor[]> {
  const { data } = await apiClient.get('/taxes/cis/subcontractors', { params: { orgId } });
  return data;
}

export async function getCis300(orgId: string, periodStart: string, periodEnd: string): Promise<Cis300Draft> {
  const { data } = await apiClient.get('/taxes/cis/cis300', { params: { orgId, periodStart, periodEnd } });
  return data;
}

export async function getUkDeadlines(orgId: string): Promise<UkTaxDeadline[]> {
  const { data } = await apiClient.get('/taxes/deadlines', { params: { orgId } });
  return data;
}

export async function getUkFilingDrafts(orgId: string): Promise<TaxFilingDraftSummary[]> {
  const { data } = await apiClient.get('/taxes/filing-drafts', { params: { orgId } });
  return data;
}

export async function markUkDraftFiled(
  orgId: string,
  draftId: string,
  body: { filedVia: 'qbo' | 'xero' | 'manual'; filedDate?: string; evidence?: string },
): Promise<TaxFilingDraftSummary> {
  const { data } = await apiClient.post(`/taxes/filing-drafts/${draftId}/mark-filed`, body, { params: { orgId } });
  return data;
}
